// extracted by mini-css-extract-plugin
export default {"text":"segmentInfo_text__OLElY","heading":"segmentInfo_heading__v+Hgk"};